// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__7b82J","logo":"style_logo__BBHn1"};